$(document).ready(function(){
 if($("body").hasClass("template-cart"))
 {
     $(document).on("change",".template__cart__body .insurance input[type='checkbox']",function(){
       $(".template__cart__body .insurance-loadr").show();
       if($(this).is(":checked"))
       {
         var id = $(this).attr("data-id");
         var qty = 1;
         add(id,qty);
       }
       else
       {
         var id = $(this).attr("data-id");
         var qty = 0;
         remove(id,qty);
       }
       
     });
 }
 else
 {
       $(document).on("change",".mini-cart__content .insurance input[type='checkbox']",function(){
         $(".mini-cart__content .insurance-loadr").show();
         if($(this).is(":checked"))
         {
           var id = $(this).attr("data-id");
           var qty = 1;
           add(id,qty);
         }
         else
         {
           var id = $(this).attr("data-id");
           var qty = 0;
           remove(id,qty);
         }

       });    
 }
  
  
function add(id,qty)
{
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {
        quantity: qty,
        id: id,
        properties:{
          "Insurance":"Yes"
        }
      },
      dataType: 'json', 
      success: function (data) {
        if($("body").hasClass("template-cart"))
 		{
         location.reload();
        }
        else
        {
          document.documentElement.dispatchEvent(new CustomEvent('product:added', {
            bubbles: true,
            detail: {
              quantity: 1
            }
          }));
          
        }
      }
    });
}
  
function remove(id,qty)
{
    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: {
        quantity: qty,
        id: id
      },
      dataType: 'json', 
      success: function (data) { 
        if($("body").hasClass("template-cart"))
 		{
         location.reload();
        }
        else
        {
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
            bubbles: true
          }));
        }
      }
    });
}
  
  var change = $(".insurance-change").length;
  if(change != 0)
  {
    var hsitem = $(".insurance-change").attr("data-init-id");
    var vid = $(".insurance-change").attr("data-final-id");
    
    updateInsurance(hsitem,vid);
    
  }
  
  document.addEventListener('product:added', function(event) {
    setTimeout(function () {
      var change = $(".insurance-change").length;
      console.log(change);
      if(change != 0)
      {
        var hsitem = $(".insurance-change").attr("data-init-id");
        var vid = $(".insurance-change").attr("data-final-id");

        updateInsurance(hsitem,vid);

      }
    }, 1000);  
  });
  

  
  function updateInsurance(hsitem,vid){
  	$("button[name='checkout'],.checkout-upsell-mini").attr("disabled",'disabled');
    $(".insurance-loadr").show();
    $(".insurance-error").show();
    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: {
        quantity: 0,
        id: hsitem
      },
      dataType: 'json', 
      success: function (data) {
        if(vid != "")
        {
         $.ajax({
           type: 'POST',
           url: '/cart/add.js',
           data: {
             quantity: 1,
             id: vid,
             properties:{
               "Insurance":"Yes"
             }
           },
           dataType: 'json', 
           success: function (data) {
              if($("body").hasClass("template-cart"))
              {
                  location.reload();
              }
              else
              {
                document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                  bubbles: true
                }));

              }
            }
          });
        }
        else
        {
          $("button[name='checkout'],.checkout-upsell-mini").remove("disabled");
          $(".insurance-loadr").hide();
          $(".insurance-error").hide();
          if($("body").hasClass("template-cart"))
          {
             location.reload();
          }
          else
          {
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
               bubbles: true
            }));

          }
        }
       }
     });
  }  

});